import { RedoFulfillmentToteGroupSchema } from "@redotech/redo-fulfillment-common/fulfillment-tote-group";
import { RedoFulfillmentToteSchema } from "@redotech/redo-fulfillment-group-common/fulfillment-tote";
import * as z from "zod";

export const getAllTeamTotes = {
  name: "getAllTeamTotes" as const,
  input: z.object({}),
  output: z.object({
    totes: z.array(RedoFulfillmentToteSchema),
    toteGroups: z.array(RedoFulfillmentToteGroupSchema),
  }),
};
